import { selectHypothesisVersions } from 'features/hypotheses/hypothesisSlice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import isVersioningPhase1Enabled from 'common/helpers/featureFlags';
import { selectAnalysisVersions } from 'features/analyses/analysisSlice';

type VersionSlice = Array<{
  isPreviousVersion: boolean;
  isCurrentVersion: boolean;
  isSelected: boolean;
  contentId: number;
  dateModified: string;
  dateShared: string | null;
  modifiedBy: string;
  sharedBy: string | null;
  versionNumber: number;
  versionStatus: number;
}>;

function isPrevSelected(versions: VersionSlice) {
  const versionPreviousSelected = versions.find(
    ({ isPreviousVersion, isSelected }) => isPreviousVersion && isSelected
  );
  if (versionPreviousSelected) {
    return true;
  }
  return false;
}

export const useIsPreviousVersionSelected = (): boolean => {
  const selectedVersionsKFA = useSelector(
    selectHypothesisVersions
  ) as VersionSlice | null;

  const selectedVersionsFFA = useSelector(
    selectAnalysisVersions
  ) as VersionSlice | null;

  const isPreviousVersionSelected = useMemo(() => {
    if (isVersioningPhase1Enabled && selectedVersionsKFA) {
      return isPrevSelected(selectedVersionsKFA);
    }
    if (isVersioningPhase1Enabled && selectedVersionsFFA) {
      return isPrevSelected(selectedVersionsFFA);
    }
    return false;
  }, [selectedVersionsKFA, selectedVersionsFFA]);

  return isPreviousVersionSelected;
};
